import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { getAboutYouUserList } from "../../http/dashboard";

const questionsArr = [
  { title: "Sr No.", key: "idx" },
  {
    title:
      "After you arrive in Canada, one of the most important things you’ll do is find a place to live. You might be renting, owning, or living in temporary housing. Or, you might be staying with family or friends for free. Which of the below options best describes your living situation?",
    key: "isHomeRent",
    minWidth: "500px",
  },
  {
    title: "How much is your mortgage on a monthly basis?",
    key: "mortgage",
  },
  {
    title: "Home insurance",
    key: "homeInsurance",
  },
  {
    title: "Home maintenance",
    key: "homeMaintenance",
  },
  {
    title: "Property taxes",
    key: "propertyTax",
  },
  {
    title: "Condo Fee",
    key: "condoFee",
  },
  {
    title: "How much do you pay for tenant insurance?",
    key: "tenantInsurance",
  },
  {
    title: "How much rent do you pay monthly?",
    key: "RentAmount",
  },
  {
    title: "How much do you spend on utilities?",
    key: "utilitiesAmount",
  },
  {
    title: "Groceries",
    key: "groceriesCost",
  },
  {
    title: "Eating Out",
    key: "FoodCost",
  },
  {
    title: "Cellphone bills",
    key: "mobileBill",
  },
  {
    title: "Internet Expense",
    key: "internetCost",
  },
  {
    title: "Subscriptions",
    key: "subscriptionBill",
  },
  {
    title: "How much money will you be sending to support your family?",
    key: "sendHomeAmount",
  },
  {
    title: "Let’s talk about transportation. Do you have a vehicle?",
    key: "ownCar",
  },
  {
    title: "Which of the below options applies to you?",
    key: "carStatus",
  },
  {
    title: "How much do you pay each month for your vehicle?",
    key: "carPayment",
  },
  {
    title: "How much do you pay for car insurance?",
    key: "carInsurance",
  },
  {
    title: "Vehicle maintenance costs",
    key: "maintanenceCost",
  },
  {
    title: "Gas costs",
    key: "gasCost",
  },
  {
    title: "How much do you spend on transportation each month?",
    key: "transportCost",
  },
  {
    title: "Clothing",
    key: "clothesCost",
  },
  {
    title: "Footwear",
    key: "footwearCost",
  },
  {
    title: "Gifts",
    key: "giftCost",
  },
  {
    title: "How much do these additional expenses cost you each month?",
    key: "additionalExpense",
    type: "array",
    minWidth: "400px",
  },
  {
    title: "How much do you spend on entertainment each month?",
    key: "entertainmentCost",
  },
  {
    title: "How much are you saving each month?",
    key: "currentSavingUp",
    type: "array",
    minWidth: "400px",
  },
  {
    title: "Do you have any debt, including any loans back home?",
    key: "debtDetails",
    type: "array",
    isDebt: true,
    minWidth: "400px",
  },
];
export default function ExpenseTable(props) {
  const { listData, handleChangePage, page, totalCount } = props;
  console.log(page, totalCount, "fdsfsd");
  return (
    <>
      <TableContainer
        component={Paper}
        sx={{ maxHeight: "calc(100vh - 210px)", overflow: "auto" }}
      >
        <Table sx={{ minWidth: 650 }} aria-label="sticky table" stickyHeader>
          <TableHead>
            <TableRow
              sx={{
                position: "sticky",
                top: 0,
              }}
            >
              {questionsArr?.map((ques) => {
                return (
                  <TableCell
                    sx={{
                      minWidth: ques.minWidth || "200px",
                      color: "#000",
                      fontSize: "15px",
                      verticalAlign: "top",
                    }}
                  >
                    {ques?.title}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {listData?.map((user, idx) => {
              return (
                <TableRow>
                  {questionsArr?.map((item) => {
                    if (item.type != "array") {
                      return (
                        <TableCell
                          sx={{
                            verticalAlign: "top",
                            color: "#768896",
                            fontWeight: 500,
                            fontSize: "14px",
                          }}
                        >
                          {item?.key === "idx" ? idx + 1 : user?.[item?.key]}
                        </TableCell>
                      );
                    }
                    if (item.isDebt) {
                      return (
                        <TableCell
                          sx={{
                            verticalAlign: "top",
                            color: "#768896",
                            fontWeight: 500,
                            fontSize: "14px",
                          }}
                        >
                          {user?.[item?.key]?.map((innerItem, idx) => {
                            return (
                              <>
                                <span>Title: {innerItem?.title}</span>
                                <br />
                                <span>Minimum Pay{innerItem?.minPay}</span>
                                <br />
                                <span>
                                  Interest Rate: {innerItem?.interestRate}
                                </span>
                                <br />
                                <span>Total Debt: {innerItem?.totalDebt}</span>
                                <br />
                                <br />
                              </>
                            );
                          })}
                        </TableCell>
                      );
                    }
                    return (
                      <TableCell
                        sx={{
                          verticalAlign: "top",
                          color: "#768896",
                          fontWeight: 500,
                          fontSize: "14px",
                        }}
                      >
                        {user?.[item?.key]?.map((innerItem, idx) => {
                          return (
                            <span>
                              {innerItem?.type}{" "}
                              {innerItem?.amount
                                ? `: ${innerItem?.amount}`
                                : ""}{" "}
                              {idx + 1 != user?.[item?.key]?.length ? (
                                <br />
                              ) : (
                                ""
                              )}
                            </span>
                          );
                        })}
                      </TableCell>
                    );
                  })}{" "}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        sx={{
          width: "100%",
          "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
            {
              fontSize: "14px",
            },
          "& .MuiTablePagination-selectLabel, & .MuiTablePagination-select, & .MuiTablePagination-actions .MuiIconButton-root":
            {
              color: "black",
            },
        }}
        component={"div"}
        colSpan={3}
        count={totalCount}
        rowsPerPage={10}
        page={page}
        slotProps={{
          select: {
            inputProps: {
              "aria-label": "rows per page",
            },
            native: true,
          },
        }}
        rowsPerPageOptions={[]}
        onPageChange={handleChangePage}
      />
    </>
  );
}
